module.exports = __webpack_public_path__ + "static/media/price-icon.e0dbef79.svg";